import { render, staticRenderFns } from "./Registerei.vue?vue&type=template&id=19e93c26&scoped=true&"
import script from "./Registerei.vue?vue&type=script&lang=js&"
export * from "./Registerei.vue?vue&type=script&lang=js&"
import style0 from "./Registerei.vue?vue&type=style&index=0&id=19e93c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e93c26",
  null
  
)

export default component.exports